import Pharms from './pharms';
import Partenrs from './partners';

const API = {
  Pharms: Pharms,
  Partenrs: Partenrs,
};

export default API;
